export const isNullOrEmpty = (value) => {
  return [null, ""].includes(value);
};

export const valueOrDefault = (value, defaultValue = 0) => {
  return value || defaultValue;
};


export const getValueConditionally = (
  condition,
  positiveResult,
  negativeResult
) => {
  return condition ? positiveResult : negativeResult;
};